<template>
  <div class="uploadBox pad40 clear">
    <!-- 表单重新上传弹窗 -->
    <k-dialog
      class="uploadModel"
      ref = "uploadDialog"
      :options = "{title: clsInfo.IMG_CLS_NAME, center:true,width: '80%',height:900,top:'0',destroyOnClose:false,
      isCanClickClose: false,showClose: true,
      onCloseBefore: closeUploadBox,
      buttons: isQuickCollectFlag ? [{text: '下一步', handler: confirmBtnHandler}] : [{text:'取消', handler: closeUploadBox},
      {text: '确定', handler: confirmBtnHandler}]
      }">
      <div class="oper-img">
        <span @click="editCheckFrom" v-if="!isQuickCollectFlag" class="oper-img-edit">{{ isShowCheckFrom ? "取消编辑":"编辑" }}</span>
        <el-checkbox style="text-indent: 0.5em; font-size: 0.18rem" v-if="isDelFrom" v-model="chooseAll" @change="checkFromAll">全选</el-checkbox>
        <span @click="deleteCheckFrom" v-if="isDelFrom" class="oper-img-del">删除勾选图片</span>
      </div>
      <div class="uploadModelCon">
        <div class="imageCon" :key="index" v-for="(item, index) in clsInfo.IMG_DATA">
          <img v-if="clsInfo.IMG_FMT === '5'" @change="checkFrom($event, item, index)" class="imagesDiv cursor smallPdf" src="@img/newCode/imgUploadBox/pdfFile.svg" />
          <div class="pdfName" v-if="clsInfo.IMG_FMT === '5'">{{ clsInfo.IMG_CLS_NAME }}</div>
          <img v-else @change="checkFrom($event, item, index)" class="imagesDiv cursor" :src="getSrc(item)" />
          <el-checkbox :ref="'checkFrom' + index" v-model="checkList[index]" v-if="isDelFrom" @change="checkFrom($event, item, index)"  class="uploadListCover-check"></el-checkbox>
          <div v-if="isShowFromHover" class="uploadListCover">
            <img src="@img/newCode/imgUploadBox/check.png" @click="showExamplesFn(index)" class="cursor" />
            <img v-if="!isQuickCollectFlag" src="@img/newCode/imgUploadBox/delete.png" @click="delImg(item, index, true)" class="cursor" />
            <img src="@img/newCode/imgUploadBox/redo.png" @click="reTakePicture(item, index)" class="cursor redo" />
          </div>
        </div>
        <div class="uploadBtn">
          <input type="file" style="display: none" ref="formUploadModalBtn" @change="formUploadBtn" multiple accept=".pdf,.jpg,image/jpeg,image/png" />
          <img class="addIcon cursor" src="@img/newCode/imgUploadBox/add.png" @click="formUploadImg" />
          <div class="addFont">点击上传</div>
        </div>
      </div>
    </k-dialog>
    <!-- 图片放大弹窗 -->
    <showBigImg
      class="showBigImgBox"
      :fileSrc="clsInfo.IMG_DATA[bigImgIndex] && getSrc(clsInfo.IMG_DATA[bigImgIndex])"
      :title="clsInfo.IMG_CLS_NAME"
      :isPdf="clsInfo.IMG_FMT === '5'"
      @cancelBigImg="cancelBigImg"
      v-if="isShowBigImg"
    ></showBigImg>
  </div>
</template>

<script>
import kDialog from "../../common/dialog.vue";
import imgTools from "@/components/imageNode/child/imgTools";
import showBigImg from "./showBigImg.vue";

export default {
  components: {
    kDialog,
    showBigImg
  },
  props: ["isShowBox", "clsInfo", "isQuickCollectFlag"],
  data () {
    return {
      chooseAll: false, //全选标志
      isShowCheckFrom: false,
      isDelFrom: false,
      isShowFromHover: true,
      deleteImgList: [],
      bigImgIndex: 0,
      reTake: false,
      reTakeIndex: -1,
      isShowBigImg: false,
      checkList:[],
    };
  },
  watch: {
    isShowBox: {
      handler (newVal) {
      },
      immediate: true
    },
    deleteImgList () {
      if (this.deleteImgList.length < this.clsInfo.IMG_DATA.length) {
        this.chooseAll = false;
      }
      if (this.deleteImgList.length == this.clsInfo.IMG_DATA.length) {
        this.chooseAll = true;
      }
      if (this.deleteImgList.length == 0) {
        this.chooseAll = false;
      }
    }
  },
  computed: {
  },
  async created () {
  },
  mounted () {
    consoleLog("uploadBox mounted", this.clsInfo.IMG_CLS);
    this.$refs.uploadDialog.open();
  },
  beforeRouteLeave (to, from, next) {},
  beforeDestroy () {},
  methods: {
    async closeUploadBox () {
      //取消或者关闭
      this.$emit("closeUploadBox");
      this.cleanData();
    },
    getSrc (item){
      if(item.localImgUrl&&item.localImgUrl.startsWith("blob:http:")){
        return item.localImgUrl;
      }
      if(!item.imgSrc){
        return "";
      }
      let base64Str = "data:image/jpg;base64," + item.imgSrc.replace(/data:(.*?),/, "");
      let localImgUrl = imgTools.getBase64URL(base64Str);
      item.localImgUrl = localImgUrl;
      return item.localImgUrl;
    },
    confirmBtnHandler () {
      this.$emit("uploadOk");
      this.cleanData();
    },
    cleanData () {
      this.deleteImgList = [];
      this.isShowCheckFrom = false;
      this.isDelFrom = false; //关闭上传窗口时，删除图片不显示
      this.isShowFromHover = true;
    },
    //显示大图
    showExamplesFn (index) {
      this.isShowBigImg = true;
      this.bigImgIndex = index;
    },
    //重拍
    reTakePicture (item, index) {
      this.reTakeIndex = index;
      this.reTake = true;
      this.$refs.formUploadModalBtn.value = "";
      this.$refs.formUploadModalBtn.click(item, index);
    },
    cancelBigImg () {
      this.isShowBigImg = false;
    },
    async delImg (item) {
      this.deleteImgList = [item.PAGE_NUM];
      this.removeImg();
    },
    async removeImg () {
      return new Promise(resolve=>{
        this.$emit("removeImg",this.clsInfo.IMG_CLS, this.clsInfo.IMG_SN, this.deleteImgList, (flag)=>{
          consoleLog("删除完成 关闭编辑模式");
          // this.deleteImgList = [];
          this.editCheckFrom();
          return resolve(true);
        });
      });
    },
    //表单上传编辑
    editCheckFrom () {
      //先校验，校验通过了才展示具体编辑页面
      let that = this;
      this.$emit("imgValidate", () => {
        that.isShowCheckFrom = !that.isShowCheckFrom;
        if (that.isShowCheckFrom) {
          that.isDelFrom = true;
          that.isShowFromHover = false;
        } else {
          that.isDelFrom = false;
          that.isShowFromHover = true;
          if (that.deleteImgList.length) {
            //关闭编辑模式，清空删除数组
            that.deleteImgList.splice(0, that.deleteImgList.length);
            that.checkList = [];
          }
        }
      });
    },
    //表单上传勾选
    checkFrom (flag, val, index) {
      if (this.isShowCheckFrom) {
        if (this.checkList[index] == true) {
          //如果勾选，将图片添加到删除列表
          this.deleteImgList.push(val.PAGE_NUM);
        }
        if (this.checkList[index] == false) {
          this.deleteImgList = this.deleteImgList.filter(item => {
            return item != val.PAGE_NUM;
          });
        }
      }
    },
    //表单删除删除图片
    deleteCheckFrom () {
      if (this.deleteImgList.length == 0) {
        this.alert("请勾选图片");
        return;
      }
      let that = this;
      that.confirm({
        messageText: "您确定要删除所选图片？",
        confirmButtonText: "确定",
        confirmedAction: function () {
          that.removeImg();
        }
      });
    },
    formUploadBtn (file) {
      //上传前清除定时器
      // this.clearTime()
      let files = file.target.files;
      this.upload(files, this.clsInfo.IMG_CLS);
    },
    formUploadImg () {
      //重置重拍标记
      this.reTakeIndex = -1;
      this.$refs.formUploadModalBtn.value = "";
      this.$refs.formUploadModalBtn.click();
    },
    //公共上传逻辑
    async upload (files, IMG_CLS) {
      if(this.isQuickCollectFlag){
        //批量采集
        this.$emit("quickUpload", files, IMG_CLS);
      }else{
        this.$emit("upload", files, IMG_CLS, undefined, this.reTakeIndex);
      }
    },
    //表单全选
    checkFromAll (val) {
      let oldArr = this.clsInfo.IMG_DATA;
      if (val) {
        this.deleteImgList = [];
        oldArr.forEach((item, index) => {
          this.checkList[index] = true;
          this.deleteImgList.push(item.PAGE_NUM);
        });
      } else {
        oldArr.forEach((item, index) => {
          this.checkList[index] = false;
        });
        this.deleteImgList = [];
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.uploadModelCon {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.2rem;
}
.uploadModelCon div {
  // margin-right: 0.2rem;
  margin-bottom: 0.2rem;
}
.imagesDiv {
  max-width: 2.7rem;
  max-height: 2.7rem;
}
.uploadListCover {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
.imageCon:hover .uploadListCover {
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploadListCover img{
  width: 50px;
  margin-right: 0.3rem;
}
// .uploadListCover img:first-child {
//   margin-right: 0.42rem;
// }
.imageCon {
  width: 2.8rem;
  height: 2.8rem;
  background: #ffffff;
  border: 1px solid #ebeef3;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;
  align-items: normal;
  .pdfName {
    width: 100%;
    text-align: center;
    margin: 0;
  }
}

.addIcon {
  width: 0.68rem;
  height: 0.68rem;
}
.addFont {
  position: absolute;
  bottom: 0.46rem;
}
.uploadBtn {
  .fontsize-btn-medium();
  width: 2.8rem;
  height: 2.8rem;
  background: #f7f7f7;
  border-radius: 5px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  color: #9a9a9a;
}
.oper-img {
  margin-top: -20px;
  height: 0.5rem;
  font-size: 0.16rem;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /deep/.el-checkbox{
    line-height: 1;
    .el-checkbox__input{
      width:14px;
      height:14px;    
    }
    .el-checkbox__label{
      padding: 0;
      font-size: 14px;
    }
  }
}
.oper-img .oper-img-edit {
  color: #007acc;
}
.oper-img .oper-img-del {
  color: #da4f43;
  text-indent: 0.5em;
}
.uploadListCover-check {
  position: absolute;
  bottom: 0;
  right: 0;
  /deep/ .el-checkbox__inner{
    width: 28px;
    height: 28px;
    &::after {
      height: 0.14rem;
      left: 0.1rem;
      top: 2px;
      width: 0.06rem;
    }
  }
}

/* .uploadModel >>> .ivu-btn-text {
  display: none;
} */
@media screen and (max-width: 1440px) {
  .btn {
    font-size: 12px;
  }
  .tabs {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/uploadBox.vue